<template>
    <div>
        <div class="resource__attributionPerson">
            <v-avatar :user-id="data.posted_by_user_id" :size="24" inline />
            clipped by
            <user-name :user-id="data.posted_by_user_id" />

            via
            <span v-if="data.posted_via === 'Slack'">
                <a
                    v-if="data.slack_url"
                    :href="data.slack_url"
                    target="_blank"
                    rel="noopener noreferrer">
                    {{ data.posted_via }}
                </a>
                <span v-if="!data.slack_url">
                    {{ data.posted_via }}
                </span>
            </span>
            <span v-if="data.posted_via !== 'Slack'">web</span>

            on
            <time-stamp class="resource__postedAt" :datetime="data.submitted_at" />

        </div>
        <div class="content resource__attributionNote"
          v-html="data.insight"
          v-bind:contenteditable="isModerate"
          v-bind:disabled="isSaving"
          v-on:blur="updateResourceInsight"
          :id="'resource__attributionNote'+data.id"
          ></div>
    </div>
</template>

<script>

import Avatar from './Avatar';
import UserName from './UserName';
import TimeStamp from './TimeStamp';

export default {

    props: {
        data: Object,
        isModerate: {
            type: Boolean,
            default: false
        },
        isSaving: {
            type: Boolean,
            default: false
        },
    },

    components: {
        'v-avatar': Avatar,
        'user-name': UserName,
        'time-stamp': TimeStamp
    },
    methods: {
      updateResourceInsight(e) {
        this.data.insight = e.target.innerText;
      },
    },
    watch: {
      isModerate : function(newVal, oldVal) {
        return;
        if (newVal == true) {
          var div = document.getElementById('resource__attributionNote'+this.data.id);
          setTimeout(function() {
              div.focus();
          }, 0);
        }
      }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ResourceCardAttribution.vue